<template>
  <section class="content">
    <message
      :obj=reporting.message
      hide-mutation-type="CLEAR_REPORTING_MESSAGE">
    </message>

    <div class="reporting-filters col-sm-4 col-md-4">
      <span>Dates</span>
      <div id="date">
        <span>Du</span>
        <datepicker class="form-control" language="fr" v-model="reporting.fromFilterDate" v-on:selected="getTournees"
                    @opened="fromDateOpened"></datepicker>
        <span>Au</span>
        <datepicker class="form-control" language="fr" v-model="reporting.toFilterDate" v-on:selected="getTournees"
                    @opened="toDateOpened"></datepicker>
      </div>
    </div>
    <div class="reporting-filters col-sm-4 col-md-4">
      <span>Tournée</span>
      <div id="tournee">
        <multiselect id="ronde" class="multiselect-class" v-model="reporting.idRonde" placeholder="Trouver une ronde"
                     label="nom" track-by="id" :options="rondesSelect" :multiple="true" @select="selectRonde"
                     @remove="removeRonde"></multiselect>
      </div>
    </div>

    <div class="reporting-filters col-sm-4 col-md-4">
      <span>Agent</span>
      <div id="agent">
        <multiselect ref="agentMultiselect" id="ronde" class="multiselect-class" v-model="reporting.idAgent"
                     placeholder="Trouver un agent" label="fullName" track-by="id" :options="agentsSelect"
                     :multiple="true" @select="selectAgent" @remove="removeAgent"></multiselect>
      </div>
      <br>
      <br>

      <button type="button"
              v-on:click="search()"
              :disabled="reporting.searching === true"
              class="btn btn-secondary blue-button right-padding"><img src="../../../../static/img/btn-export.svg">
        Exporter
      </button>
    </div>

    <div class="loading-overlay" v-if="reporting.searching">
      Chargement ...
    </div>

  </section>

</template>

<script>
import {mapState} from 'vuex'
import Datepicker from 'vuejs-datepicker'
import Message from '../../shared/Message'
import dateFormatter from '../../../utils/dateFormatter'
import Multiselect from 'vue-multiselect'
import Papa from 'papaparse'
import moment from 'moment'
import timeFormatter from '../../../utils/timeFormatter'

export default {
  components: {
    Datepicker,
    Message,
    Multiselect,
  },
  data: function () {
    return {
      mounted: false,
      agentsSelect: [],
      rondesSelect: [],
      selectedAgents: null,
      selectedRondes: null,
      value: null,
      from: null,
      to: null,
      fromDatePickerOpened: false,
      toDatePickerOpened: false,
    }
  },
  computed: {
    ...mapState([
      'reporting',
      'rondes',
    ]),
    sortedAgents: function () {
      return this.$store.getters.sortedAgents
    },
  },
  mounted: async function () {
    this.$store.commit('SHOW_REPORTING_LOADING')
    await this.$store.dispatch('fetchAgentsV2')
    await this.$store.dispatch('fetchRondesV2')
    this.getTournees()
    this.mounted = true
  },
  beforeDestroy () {
    console.log('Leaving the page - Perform cleanup here')
    this.reporting.idAgent = []
    this.reporting.idRonde = []
    this.agentsSelect = []
    this.rondesSelect = []
    this.selectedAgents = null
    this.selectedRondes = null
  },
  updated: function () {
  },
  methods: {
    search: async function () {
      this.$store.commit('SHOW_REPORTING_LOADING')
      let agentIds = []
      let rondeIds = []

      this.reporting.idAgent.forEach(function (agent) {
        agentIds.push(agent.id)
      })
      this.reporting.idRonde.forEach(function (ronde) {
        rondeIds.push(ronde.id)
      })

      await this.$store.dispatch('searchTourneeForReporting', {
        fromDate: dateFormatter(this.$store.state.reporting.fromFilterDate),
        toDate: dateFormatter(this.$store.state.reporting.toFilterDate),
        agentIds: agentIds,
        rondeIds: rondeIds,
      })

      this.asignCsvValue(this.reporting.result)
      // console.log("Reporting :: " , this.reporting.result)
    },
    clear: function () {
      this.$store.dispatch('clearReportingFilters')
    },
    selectAgent: function (selectedOption) {
    },
    removeAgent: function () {
    },
    selectRonde: function (selectedOption) {
      setTimeout(async () => {
        console.log('selected ronde ::: ', selectedOption)
        console.log('reporting.idRonde ::: ', this.reporting.idRonde)
        this.reorganizeAgents()
      }, 50)
    },
    removeRonde: function () {
      setTimeout(async () => {
   /*      this.agentsSelect = []
        this.selectedRonde = null */
        this.reorganizeAgents()
      }, 50)
    },
    reorganizeAgents: function () {
      var that = this
      this.agentsSelect = []
      this.$store.state.reporting.idRonde.forEach(function (ronde) {
        console.log('ronde => ', ronde)
        let agentForRondes = that.reporting.agents.filter(a => a.ronde_id === ronde.id)
        that.agentsSelect.push(...agentForRondes)
        that.agentsSelect = that.getUniqueValues(that.agentsSelect)
      })
      console.log('-fil agents li kaynin fel input ', that.reporting.idAgent)
      that.reporting.idAgent.forEach(function (agent) {
        console.log("-agent :: ", agent)
        console.log("-that.reporting.idRonde :: ", that.reporting.idRonde)
        let ag = that.reporting.idRonde.find(r => r.id === agent.ronde_id)
        console.log('-fil ag :: ', ag)
        if (!ag) {
          console.log('-fil remove this :: ', agent)
          that.reporting.idAgent = that.reporting.idAgent.filter(ag => ag.id !== agent.id)
        }
      })
      that.reporting.idRonde.forEach(function (ronde) {
        console.log('- ronde => ', ronde)
        let agentForRondes = that.reporting.agents.filter(a => a.ronde_id === ronde.id)
        that.reporting.idAgent.push(...agentForRondes)
        that.reporting.idAgent = that.getUniqueValues(that.reporting.idAgent)
      })
      console.log('agents li ba9in fel input ', that.reporting.idAgent)
    },
    reorganizeRondes: function () {
    },
    getTournees: function () {

      if (this.mounted) {
        this.$store.commit('SHOW_REPORTING_LOADING')
      }

      setTimeout(async () => {
        console.log('get tournees')
        console.log('from :: ', this.reporting.fromFilterDate)
        console.log('to   :: ', this.reporting.toFilterDate)

        await this.$store.dispatch('searchTourneeOnlyForReporting', {
          fromDate: dateFormatter(this.$store.state.reporting.fromFilterDate),
          toDate: dateFormatter(this.$store.state.reporting.toFilterDate)
        })

        // this.agentsSelect = _.cloneDeep(this.reporting.agents)
        this.rondesSelect = _.cloneDeep(this.reporting.rondes)
      }, 50)
    },
    fromDateOpened: function () {
      this.fromDatePickerOpened = true
      this.toDatePickerOpened = false
    },
    toDateOpened: function () {
      this.toDatePickerOpened = true
      this.fromDatePickerOpened = false
    },
    getUniqueValues: function (array) {
      const uniqueSet = new Set()
      return array.filter(item => {
        if (!uniqueSet.has(item.id)) {
          uniqueSet.add(item.id)
          return true
        }
        return false
      })
    },
    asignCsvValue: function (data) {
      var result = data.map(function (value) {
        return {
          'Date': value.date,
          'Heure': value.heure,
          'Agent': value.agent,
          'Ronde SC': value.rondeSC,
          'Commune': value.commune,
          'N° rue': value.nRue,
          'Adresse': value.adresse,
          'Anomalie': value.anomalie,
          'Collecte': value.collecte,
          'Top Action': value.topAction,
          'N° Ronde': value.nRonde,
          'Coordonnées GPS': value.coordGps,
        }
      })
      this.makeCSV(result)
    },
    makeCSV: function (data) {
      // String.format("%s;%s;%s;%s;%s;%s;%s;%s;SITA", DateFormatter.formatDDMMYYYY(d), DateFormatter.formatHHMM(d), nomRonde, adresse.getVille(), adresse.getNumero(), adresse.getVoie(), anomalieType, isBacSortieShort)
      var content = Papa.unparse({
        encoding: 'UTF-8',
        fields: [
          'Date',
          'Heure',
          'Agent',
          'Ronde SC',
          'Commune',
          'N° rue',
          'Adresse',
          'Anomalie',
          'Collecte',
          'Top Action',
          'N° Ronde',
          'Coordonnées GPS',
        ],

        data: data,
      })
      this.prompCsvDownload(content)
    },
    prompCsvDownload: function (content) {
      var csvData = new window.Blob([
        '\uFEFF' + content, // prepend utf8's BOM fixes excel import it seems
      ], {
        type: 'text/csv;charset=WINDOWS-1252;',
      })
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(csvData, 'suez_report.csv')
      } else {
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(csvData)
        link.setAttribute('download', 'suez_report.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
  },
}

</script>

<style lang="scss">
@import "../../../scss/variables";

.reporting-filters {
  .form-control {
    display: inline-block;
    min-width: 115px;
    width: 140px;
  }

  margin-bottom: 20px;
}

.multiselect-class {
  // width:20%;
  min-width: 300px;
  display: inline-block;
}

span {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Reporting.vue?6bfe3d6a